import axios from 'axios'
import React, { useState } from 'react'


const bashUrl = process.env.REACT_APP_BASH_URL;

function useProduct() {
    const [products, setProducts] = useState([])
    const [loading, setLoading] = useState(false)
    const [product, setProduct] = useState('')

    const getAllProducts = async (limit) => {
        setLoading(true)
        return await axios.get(`${bashUrl}/products?limit=${limit}`).then((response) => {
            setLoading(false)
            // console.log("response: ", response.data.result);

            setProducts(response.data.result)
            return response.data.result
        }).catch((error) => {
            setLoading(false)
            return []
        })
    }

    const getSingleProduct = async (id) => {
        setLoading(true)
        return await axios.get(`${bashUrl}/products/${id}`).then((response) => {
            setLoading(false)
            setProduct(response.data.result)
            return response.data.result
        }).catch((error) => {
            setLoading(false)
            return {}
        })
    }

    return { products, loading, getAllProducts, product, getSingleProduct }

}

export default useProduct